import { DocumentApi, UpdateOrderEirUrlCommand } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class DocumentsService {
  httpClient = createApiClient(DocumentApi)

  downloadEirDocument = async (filename: string): Promise<Blob> => {
    const { data } = await this.httpClient.downloadEirDocument(filename, { responseType: 'blob' })
    // TODO: Ensure proper typing to avoid casting
    return data as unknown as Blob
  }

  uploadEirDocuments = async (files: File[]) => {
    const { data } = await this.httpClient.uploadEirDocuments(files)

    return data
  }

  updateOrderDocumentUrl = async (cmd: UpdateOrderEirUrlCommand) => {
    await this.httpClient.updateOrderDocumentUrl(cmd)
  }
}

const documentsService = new DocumentsService()

export default documentsService
